import { NgModule } from '@angular/core';

import { SettingsPageModule } from 'pages/settings-page/settings-page.module';
import { AppSettingsPageModule } from 'pages/settings/app-settings-page.module';
import { NotificationSettingsPageModule } from 'pages/notification-settings/notification-settings-page.module';
import { CustomizeHomepagePageModule } from 'pages/customize-homepage/customize-homepage-page.module';
import { UserProfilePageModule } from 'pages/user-profile/user-profile.module';

const SETTINGS_PAGE_MODULES = [
  SettingsPageModule,
  AppSettingsPageModule,
  NotificationSettingsPageModule,
  CustomizeHomepagePageModule,
  UserProfilePageModule,
];

/**
 * The settings screens and the user's own profile.
 *
 * One of the app's per-area page groups: it only groups page modules together,
 * declaring nothing of its own and adding no providers. Why these files exist and
 * what keeps them honest: `design-docs/angular-components.md`, "Creating New
 * Components", step 4.
 */
@NgModule({
  imports: SETTINGS_PAGE_MODULES,
  exports: SETTINGS_PAGE_MODULES,
})
export class SettingsPagesModule { }
